import React from 'react';
import { Stack, Text, Button, ThemeIcon } from '@mantine/core';
import { IconDatabaseOff } from '@tabler/icons-react';
import type { EmptyStateProps } from '../../theme/mantineTheme';

/**
 * Unified empty state component used across tables, lists, and content areas.
 * Provides a consistent visual pattern: centered icon + title + description + optional action.
 */
export function EmptyState({
    icon: Icon = IconDatabaseOff,
    title,
    description,
    actionLabel,
    onAction,
}: EmptyStateProps) {
    return (
        <Stack align="center" gap="sm" py="xl" px="md">
            <ThemeIcon variant="light" color="gray" size={48} radius="xl">
                <Icon size={24} stroke={1.5} />
            </ThemeIcon>
            <Text size="sm" fw={500} c="dimmed" ta="center">
                {title}
            </Text>
            {description && (
                <Text size="xs" c="dimmed" ta="center" maw={360}>
                    {description}
                </Text>
            )}
            {actionLabel && onAction && (
                <Button variant="light" size="xs" mt="xs" onClick={onAction}>
                    {actionLabel}
                </Button>
            )}
        </Stack>
    );
}
